import React from 'react'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { Doughnut } from 'react-chartjs-2'
import { renderStateName, renderTaskName } from '../../../process/util/names'

const DOUGHNUT_OPTIONS = {
    legend: {
        display: false,
    },
}

const COLOR_LIST = [
    'rgb(0,145,231)',
    'rgb(255,193,44)',
    'rgb(255,138,0)',
    'rgb(255,63,107)',
    'rgb(18,178,178)',
    'rgb(133,70,255)',
    'rgb(186,188,193)',
    'rgb(0,145,231)',
    'rgb(255,193,44)',
    'rgb(255,138,0)',
    'rgb(255,63,107)',
    'rgb(18,178,178)',
    'rgb(133,70,255)',
    'rgb(186,188,193)',
]


const compileDoughnutData = (stateList, property) => {
    return {
        labels: stateList.map(entry => {
            return renderStateName(entry[property])
        }),
        datasets: [{
            data: stateList.map(entry => {
                return entry.count
            }),
            backgroundColor: COLOR_LIST,
            hoverBackgroundColor: COLOR_LIST,
        }],
    }
}

const CurrentStateAndTask = ({ stateAnalytics, getStateLastChanged, getTaskByDueDate }) => {
    if (!stateAnalytics || !stateAnalytics.state) {
        return null
    }
    return (
        <ContentBox title="Current States & Tasks">
            <Row>
                <Column size={4}>
                    <h3>Current States</h3>
                    <Doughnut
                        options={DOUGHNUT_OPTIONS}
                        data={compileDoughnutData(stateAnalytics.state, 'currentStateName')}
                    />
                </Column>
                <Column size={4}>
                    <h3>Current Tasks</h3>
                    <Doughnut
                        options={DOUGHNUT_OPTIONS}
                        data={compileDoughnutData(stateAnalytics.task, 'name')}
                    />
                </Column>
                <Column size={4}>
                    <h3>Overdue Tasks</h3>
                    <Doughnut
                        options={DOUGHNUT_OPTIONS}
                        data={compileDoughnutData(stateAnalytics.taskOverdue, 'name')}
                    />
                </Column>
            </Row>
            <Row>
                <Column size={4}>
                    <StateTable stateList={stateAnalytics.state} getStateLastChanged={getStateLastChanged}/>
                </Column>
                <Column size={4}>
                    <TaskTable taskList={stateAnalytics.task} getTaskByDueDate={getTaskByDueDate}/>
                </Column>
                <Column size={4}>
                    <TaskTable taskList={stateAnalytics.taskOverdue} getTaskByDueDate={getTaskByDueDate}/>
                </Column>
            </Row>
        </ContentBox>)
}

const StateTable = ({ stateList, getStateLastChanged }) => {
    return (
        <table className="default-table">
            <thead>
                <tr>
                    <th>State</th>
                    <th className="align-right" style={{ width: '15%' }}>#</th>
                </tr>
            </thead>
            <tbody>
                {
                    stateList.map((state, index) => {
                        return (
                            <tr key={index}>
                                <td>
                                    <a
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                            getStateLastChanged(state.currentStateName)
                                        }}>{renderStateName(state.currentStateName)}</a>
                                </td>
                                <td className="align-right">{state.count}</td>
                            </tr>)
                    })
                }
            </tbody>
        </table>
    )
}

const TaskTable = ({ taskList, getTaskByDueDate }) => {
    return (
        <table className="default-table">
            <thead>
                <tr>
                    <th>Task</th>
                    <th className="align-right" style={{ width: '15%' }}>#</th>
                </tr>
            </thead>
            <tbody>
                {
                    taskList.map((task, index) => {
                        return (
                            <tr key={index}>
                                <td>
                                    <a
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                            getTaskByDueDate(task.name)
                                        }}> {renderTaskName(task.name)}</a>
                                </td>
                                <td className="align-right">{task.count}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>)
}


export default CurrentStateAndTask



// WEBPACK FOOTER //
// ./src/modules/analytics/component/state-responsible/CurrentStateAndTask.js